// Internal Imports
import { get, post } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const postUserConsent = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.BLOCKCHAIN_SETTINGS_CONSENT}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `blockchainServices => getUserConsentBlockchainSettings => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getUserConsent = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.BLOCKCHAIN_SETTINGS_CONSENT}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetFolderTreeService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getDocumentHashes = docID =>
  new Promise((resolve, reject) => {
    get(`${APIS.BLOCKCHAIN_DOC_HASHES}/${docID}/hash`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `assetServices => getAssetFolderTreeService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const postTransactionHash = (docID, hashID, txnHash) =>
  new Promise((resolve, reject) => {
    post(`${APIS.BLOCKCHAIN_DOC_HASHES}/${docID}/hash/${hashID}`, {
      transaction_hash: txnHash,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `blockchainServices => postTrasnsactionHash => Error : ${error}`,
        );
        reject(error);
      });
  });

export const getUploadedDocMetaData = docID =>
  new Promise((resolve, reject) => {
    get(`${APIS.BLOCKCHAIN_DOC_HASHES}/${docID}/order`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `blockchainServices => getUploadedDocMetaData => Error : ${error}`,
        );
        reject(error);
      });
  });
